// removed by extract-text-webpack-plugin
module.exports = {"iconProps":"thanks-container__iconProps__1CkJG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/panels/thanks-container.scss
// module id = 1769
// module chunks = 1